import LsdApiModel from './global/LsdApiModel';

export default class ExpensePaymentVoucherIdModel extends LsdApiModel {
	static get path(): string {
		return '/expense_payment_vouchers/ids/{?id}';
	}
}
